import React, { Component } from "react";
import { Route } from "react-router-dom";
// Import Font Awesome Icons Set
import "@fortawesome/fontawesome-free/css/all.min.css";
// Import Simple Line Icons Set
import "simple-line-icons/css/simple-line-icons.css";
import "pixeden-stroke-7-icon/pe-icon-7-stroke/dist/pe-icon-7-stroke.min.css";
import ProgressBar from "./components/ProgressBar";

const Main = React.lazy(() => import("./views/Main"));
const loading = () => <div className="animated fadeIn pt-3 text-center">Carregando...</div>;

class App extends Component {
  render() {
    return (
      <div>
        <ProgressBar />
        <React.Suspense fallback={loading()}>
          <Route path="/" component={Main} />
        </React.Suspense>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js